import { useNavigation } from '@app/hooks/useNavigation';
import { useEffect, useState } from 'react';
import { Layout } from '../Layout/Layout';
import { ChatV2 } from '@components/block/ChatV2/ChatV2';
import { AuditSummaryV2 } from '@components/block/AuditSummaryV2/AuditSummaryV2';
import { useRouteMatch } from 'react-router-dom';

export function Audit() {
  const { navigation, setNavigation } = useNavigation();
  const {
    params: { applicationId },
  } = useRouteMatch<{ applicationId?: string }>();

  // Default application ID for testing
  const auditAppId = applicationId || 'app-dse-privacy-policy-create';

  useEffect(() => {
    if (navigation.scope !== 'dashboardv2') {
      setNavigation((nav) => void (nav.scope = 'dashboardv2'));
    }
  }, [navigation, setNavigation]);

  const [isChatBlocked, setIsChatBlocked] = useState(false);

  return (
    <Layout title="Audit">
      <div className="pt-4 flex flex-col md:flex-row w-full h-[calc(100vh-103px)] md:h-[calc(100vh-110px)] 2xl:h-[calc(100vh-180px)] gap-4 2xl:gap-10">
        {/* Hide chat panel on mobile, show only on desktop */}
        <div className="hidden md:flex md:w-2/3 h-full">
          <div className="flex flex-col h-full w-full">
            <div className="flex-shrink-0 inline-block border-b-2 border-primary-root pb-3 w-60 mb-6 px-20">
              <h3 className="text-primary-400 font-semibold">DSE Audit</h3>
            </div>
            <div className="flex-grow overflow-auto">
              <ChatV2 applicationId={auditAppId} disableInput={isChatBlocked} />
            </div>
          </div>
        </div>
        {/* Summary panel takes full width on mobile, 1/3 on desktop */}
        <div className="w-full md:w-1/3 h-full">
          <AuditSummaryV2 applicationId={auditAppId} setChatBlockedFunc={setIsChatBlocked} />
        </div>
      </div>
    </Layout>
  );
}
